import * as React from 'react';
import { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MessagePlugin, Upload } from 'tdesign-react';

import { MediaConfigType, RichMediaShowType } from '@/const/richMedia';
import { RichMediaValue } from '@/interface/media';

import { emitRichMediaPIC, richValueChange, transRichMediaValue } from '../change-data';
import { uploadCos } from '../service';

interface IFileInfo {
  name: string;
  url: string;
  width: number;
  height: number;
  size: number;
  localPath: string;
  media: {
    [key: string]: any;
  }
}

interface UploadFileProps {
  value: string | RichMediaValue;
  onChange: (file?: string | RichMediaValue, fileInfo?: any) => any;

  disabled?: boolean;
  alertRender?: React.ReactNode;
  childRender?: (info: IFileInfo) => React.ReactNode,
  btnText?: string;
  showSizeMsg?: string;

  limit?: {
    fileType?: string[];
    size?: number;
    showSizeMsg?: string;
  };
  dialogConfig?: any,
  multiple?: boolean,
  maxCount?: number,
  isShowRichMedia?: boolean;
  width?: number | string;
  height?: number | string;
  wrapStyle?: any;
  richMedia?: { type: MediaConfigType };
}

export const UploadFile: React.FC<UploadFileProps> = (props) => {
  const {
    width: wrapWidth = 300,
    disabled = false,
    limit,
    onChange,
  } = props;
  const [searchParams] = useSearchParams();
  const storyId = searchParams.get('id') || '';

  const fileInfo = useRef<IFileInfo>(transRichMediaValue(props.value, {
    showType: RichMediaShowType.SHOW_TYPE_INLINE,
  }) as IFileInfo);

  const handleChange: any = (fileArr: any) => {
    fileInfo.current.url = fileArr[0]?.url;
    fileInfo.current.name = fileArr[0]?.name;
    emitRichMediaPIC(fileArr[0]?.url);
    const { url, name, media } = fileInfo.current;
    fileValueChange({ ...media, url: { url, name } });
  };

  const uploadFile = async (file: any) => {
    const res = await uploadCos(file.raw, { storyId });
    if (!res?.response?.url) {
      MessagePlugin.error('上传失败,请重试');
    }
    return res;
  };

  const fileValueChange = (params?: RichMediaValue) => {
    const result = richValueChange(params);
    onChange(result);
  };

  const getNormalDom = () => <>
    <Upload
      theme={'file-input'}
      placeholder='请选择文件'
      files={[fileInfo.current]}
      disabled={disabled}
      requestMethod={uploadFile}
      onChange={handleChange}
      accept={limit?.fileType?.join(',') || undefined}
      style={{ width: wrapWidth }}
    >
    </Upload>
    {(props.alertRender) ? <div className='nova-text-tips'>{props.alertRender}</div> : null}
  </>;

  return (
    <div>
      {getNormalDom()}
    </div>
  );
};

export default UploadFile;
